<script>
import GlobalLayout from '../../marketplace-front-core/components/layout/GlobalLayout.vue'
import LayoutHeader from '@/components/layout/Header.vue'

export default {
  name: 'Checkout',
  components: { GlobalLayout, LayoutHeader }
}
</script>

<template>
  <div>
    <layout-header />
    <nuxt />
    <global-layout ref="global" />
  </div>
</template>

<style scoped lang="scss">

</style>
